import DashboardLayout from '../layout/DashboardLayout.vue';
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue';

// Admin pages
import DashboardPage from '../pages/DashboardPage';
import UserProfile from '../pages/UserProfile';
import LoginPage from '../pages/LoginPage';
import LogoutPage from '../pages/LogoutPage';
import ReceiptsPage from '../pages/ReceiptsPage';
import ManageReceiptsPage from '../pages/ManageReceiptsPage';
import DataToolsPage from '../pages/DataToolsPage';

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/scriba/dashboard',
  },
  {
    path: '/login',
    component: LoginPage,
  },
  {
    path: '/logout',
    component: LogoutPage,
  },
  {
    path: '/scriba',
    component: DashboardLayout,
    redirect: '/scriba/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardPage,
      },
      {
        path: 'receipts',
        name: 'Receipts',
        component: ReceiptsPage,
      },
      {
        path: 'admin/receipts',
        name: 'Manage Receipts',
        component: ManageReceiptsPage,
      }, {
        path: 'admin/data-tools',
        name: 'Data Tools',
        component: DataToolsPage,
      },
      {
        path: 'user',
        name: 'User Profile',
        component: UserProfile,
      },
    ],
  },
  { path: '*', component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
